// 마이페이지 모달 공통 스타일 — custom.css의 bootstrap 변수(--bs-primary 등) 색상을 그대로 사용한다.
// 그라데이션 없이 단색만 사용. 테두리는 전부 없앤다 (배경색/텍스트색만으로 구분).
//
// 주의: bootstrap.css의 reboot가 button, [type=button] 등에 -webkit-appearance: button을
// 강제로 깔아서 네이티브 버튼 테두리가 배경색 밑에 비쳐 보인다. tw-appearance-none으로 꺼야
// 테두리가 완전히 사라진다. (버튼마다 빠뜨리지 말 것)

const BTN_BASE = "tw-appearance-none tw-border-0 tw-outline-none";

export const PRIMARY_BTN =
    `${BTN_BASE} tw-rounded-lg tw-bg-[#5D87FF] tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-white tw-transition-colors hover:tw-bg-[#3464E7] disabled:tw-cursor-not-allowed disabled:tw-bg-[#A0A0A0]`;

export const SECONDARY_BTN =
    `${BTN_BASE} tw-rounded-lg tw-bg-[#F6F9FC] tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-[#495057] tw-transition-colors hover:tw-bg-[#e9ecef]`;

export const DANGER_BTN =
    `${BTN_BASE} tw-rounded-lg tw-bg-[#FF3D31] tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-white tw-transition-colors hover:tw-bg-[#d8291f]`;

export const INPUT =
    "tw-w-full tw-appearance-none tw-rounded-lg tw-border-0 tw-bg-[#F6F9FC] tw-px-3 tw-py-2 tw-text-sm tw-text-[#272B2F] tw-outline-none tw-transition-colors tw-ring-1 tw-ring-inset tw-ring-[#e9ecef] focus:tw-bg-white focus:tw-ring-2 focus:tw-ring-[#5D87FF]";

export const LABEL = "tw-mb-1 tw-block tw-text-sm tw-font-medium tw-text-[#495057]";

export const LIST = "tw-m-0 tw-list-none tw-space-y-3 tw-p-0";

export const FOOTER_END = "modal-footer tw-flex tw-justify-end tw-gap-2";
export const FOOTER_CENTER = "modal-footer tw-flex tw-justify-center tw-gap-2";

/** 되돌릴 수 없는 작업 경고 박스 — 테두리 없이 배경색 + 왼쪽 강조선만 (danger 톤, 그라데이션 없음) */
export const DANGER_CALLOUT = "tw-mb-4 tw-rounded-md tw-border-0 tw-border-l-4 tw-border-l-[#FF3D31] tw-bg-[#f8d7da] tw-p-3 tw-text-[#58151c]";

/** 테이블 — 세로 테두리 없이 가로 구분선만 */
export const TH = "tw-border-0 tw-border-b tw-border-[#e9ecef] tw-bg-[#F6F9FC] tw-px-3 tw-py-2 tw-text-left tw-text-xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-[#6c757d]";
export const TD = "tw-border-0 tw-border-b tw-border-[#f1f3f5] tw-px-3 tw-py-2 tw-text-[#272B2F]";

/** 작은 버튼 (목록 행 안의 수정/삭제 등) */
export const SMALL_PRIMARY_BTN =
    `${BTN_BASE} tw-mr-1 tw-rounded-md tw-bg-[#5D87FF] tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-text-white tw-transition-colors hover:tw-bg-[#3464E7]`;
export const SMALL_DANGER_BTN =
    `${BTN_BASE} tw-rounded-md tw-bg-[#FF3D31] tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-text-white tw-transition-colors hover:tw-bg-[#d8291f]`;
